import { useState, useEffect, useRef } from 'react';
import { useQuery } from 'react-query';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var useKeyboardNavigation = function useKeyboardNavigation(items, select, close) {
  var _useState = useState(0),
      _useState2 = _slicedToArray$1(_useState, 2),
      highlightedItemIndex = _useState2[0],
      setHighlightedItemIndex = _useState2[1];

  var lastItemIndex = items.length;

  var calculateNextIndex = function calculateNextIndex() {
    return (highlightedItemIndex + 1) % lastItemIndex;
  };

  var calculatePreviousIndex = function calculatePreviousIndex() {
    return (lastItemIndex + (highlightedItemIndex - 1)) % lastItemIndex;
  };

  var onKeyDown = function onKeyDown(event) {
    var keyCode = event.keyCode;

    switch (keyCode) {
      case 38:
        // arrow up
        setHighlightedItemIndex(calculatePreviousIndex());
        event.preventDefault();
        break;

      case 40:
        // arrow down
        setHighlightedItemIndex(calculateNextIndex());
        event.preventDefault();
        break;

      case 13:
        // enter
        items[highlightedItemIndex] && select(items[highlightedItemIndex]);
        break;

      case 27:
        // escape
        close();
        setHighlightedItemIndex(0);
        break;
    }
  };

  return {
    onKeyDown: onKeyDown,
    setHighlightedItemIndex: setHighlightedItemIndex,
    highlightedItem: items[highlightedItemIndex]
  };
};

var useOnClickOutside = function useOnClickOutside(callback) {
  var targetRef = useRef(null);

  var clickOutsideOccurred = function clickOutsideOccurred(_ref) {
    var target = _ref.target;
    return targetRef.current && !targetRef.current.contains(target);
  };

  var clickOutsideHandler = function clickOutsideHandler(event) {
    return clickOutsideOccurred(event) && callback();
  };

  useEffect(function () {
    document.addEventListener('mousedown', clickOutsideHandler);
    return function () {
      return document.removeEventListener('mousedown', clickOutsideHandler);
    };
  });
  return {
    targetRef: targetRef
  };
};

var useDropdown = function useDropdown(items) {
  var initialSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = useState(initialSelection),
      _useState2 = _slicedToArray$1(_useState, 2),
      selectedItem = _useState2[0],
      setSelectedItem = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      isOpen = _useState4[0],
      setOpen = _useState4[1];

  var open = function open() {
    return setOpen(true);
  };

  var close = function close() {
    return setOpen(false);
  };

  var _useOnClickOutside = useOnClickOutside(close),
      targetRef = _useOnClickOutside.targetRef;

  var _useKeyboardNavigatio = useKeyboardNavigation(items, setSelectedItem, close),
      _onKeyDown = _useKeyboardNavigatio.onKeyDown,
      highlightedItem = _useKeyboardNavigatio.highlightedItem,
      setHighlightedItemIndex = _useKeyboardNavigatio.setHighlightedItemIndex;

  var resetHighlight = function resetHighlight() {
    return setHighlightedItemIndex(0);
  };

  useEffect(function () {
    close();
    resetHighlight();
  }, [selectedItem]);
  return {
    isVisible: items.length && isOpen,
    getWrapperProps: function getWrapperProps() {
      return {
        ref: targetRef
      };
    },
    getTriggerProps: function getTriggerProps() {
      return {
        onMouseDown: open,
        onFocus: open,
        onKeyDown: function onKeyDown(event) {
          return open() & _onKeyDown(event);
        }
      };
    },
    getItemProps: function getItemProps(item) {
      return {
        onMouseDown: function onMouseDown() {
          return setSelectedItem(item) & close() & resetHighlight();
        },
        onMouseEnter: function onMouseEnter() {
          return setHighlightedItemIndex(items.indexOf(item));
        }
      };
    },
    selectedItem: selectedItem,
    highlightedItem: highlightedItem
  };
};

var useTimer = function useTimer(time) {
  var timer = useRef(null);

  var clearTimer = function clearTimer() {
    return timer.current && clearTimeout(timer.current);
  };

  var startTimer = function startTimer(callback) {
    return timer.current = setTimeout(callback, time);
  };

  var resetTimer = function resetTimer(callback) {
    return clearTimer() & startTimer(callback);
  };

  return {
    resetTimer: resetTimer
  };
};

var useRemoteAutocomplete = function useRemoteAutocomplete(_ref) {
  var suggestionsProvider = _ref.suggestionsProvider,
      _ref$suggestionProvid = _ref.suggestionProviderProps,
      suggestionProviderProps = _ref$suggestionProvid === void 0 ? null : _ref$suggestionProvid,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 300 : _ref$timeout,
      _ref$cacheTtl = _ref.cacheTtl,
      cacheTtl = _ref$cacheTtl === void 0 ? 15 * 60 * 1000 : _ref$cacheTtl;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      suggestions = _useState4[0],
      setSuggestions = _useState4[1];

  var _useQuery = useQuery(input && ['autocomplete', {
    input: input,
    suggestionProviderProps: suggestionProviderProps
  }], function (_ref2) {
    var input = _ref2.input,
        suggestionProviderProps = _ref2.suggestionProviderProps;
    return suggestionsProvider(input, suggestionProviderProps);
  }, {
    initialData: suggestions,
    staleTime: cacheTtl,
    cacheTime: cacheTtl,
    refetchOnWindowFocus: false
  }),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading,
      isFetching = _useQuery.isFetching;

  useEffect(function () {
    !isLoading && !isFetching && setSuggestions(data);
  }, [data, isLoading, isFetching]);

  var _useTimer = useTimer(timeout),
      resetTimer = _useTimer.resetTimer;

  var setCurrentInput = function setCurrentInput(text) {
    return resetTimer(function () {
      return setInput(text);
    });
  };

  return {
    setCurrentInput: setCurrentInput,
    suggestions: suggestions,
    isLoading: isLoading || isFetching
  };
};

var useAutocomplete = function useAutocomplete(suggestionsProvider, localFilter, suggestionProviderProps) {
  var threshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  var inputRef = useRef(null);

  var _useRemoteAutocomplet = useRemoteAutocomplete({
    suggestionsProvider: suggestionsProvider,
    suggestionProviderProps: suggestionProviderProps
  }),
      suggestions = _useRemoteAutocomplet.suggestions,
      setRemoteInput = _useRemoteAutocomplet.setCurrentInput,
      isLoading = _useRemoteAutocomplet.isLoading;

  var filteredSuggestions = suggestions.filter(localFilter(input));

  var _useDropdown = useDropdown(filteredSuggestions),
      getTriggerProps = _useDropdown.getTriggerProps,
      selectedItem = _useDropdown.selectedItem,
      isVisible = _useDropdown.isVisible,
      getWrapperProps = _useDropdown.getWrapperProps,
      getDropdownItemProps = _useDropdown.getItemProps,
      highlightedItem = _useDropdown.highlightedItem;

  useEffect(function () {
    input !== selectedItem && (input === null || input === void 0 ? void 0 : input.length) >= threshold && setRemoteInput(input);
    (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) && (inputRef.current.value = input);
  }, [input, threshold]);

  var onChange = function onChange(_ref) {
    var text = _ref.target.value;
    return setInput(text);
  };

  var getItemProps = function getItemProps(item) {
    var _getDropdownItemProps = getDropdownItemProps(item),
        dropdownOnMouseDown = _getDropdownItemProps.onMouseDown,
        dropdownItemProps = _objectWithoutProperties(_getDropdownItemProps, ["onMouseDown"]);

    return _objectSpread2({}, dropdownItemProps, {
      onMouseDown: function onMouseDown() {
        return dropdownOnMouseDown() & setInput(item);
      }
    });
  };

  return {
    suggestions: filteredSuggestions,
    getInputProps: function getInputProps() {
      return _objectSpread2({
        ref: inputRef,
        onChange: onChange
      }, getTriggerProps());
    },
    isLoading: isLoading,
    selectedItem: selectedItem,
    setInput: setInput,
    isVisible: isVisible && (input === null || input === void 0 ? void 0 : input.length) >= threshold,
    getWrapperProps: getWrapperProps,
    getItemProps: getItemProps,
    highlightedItem: highlightedItem,
    input: input
  };
};

export { useAutocomplete };
//# sourceMappingURL=index.es.js.map
